<div class="col-sm-12 col-md-8 mt-3">
  <div class="calendar" *ngIf="availableDays">
    <div class="inner-div">
      <mat-calendar #calendar [selected]="selectedDate" [startAt]="startDate" [minDate]="minDate" [maxDate]="maxDate"
        (selectedChange)="newUpdateSlots($event)" [dateFilter]="unavailableDates">
      </mat-calendar>
      <div class="availability-markers row">
        <span class="space_below"><span class="available"></span><span class="mr-4">Available</span></span>
        <span class="space_below">
          <span class="unavailable"></span><span class="mr-4">Unavailable</span></span>
        <span class="space_below"><span class="selected"></span><span class="mr-4">Selected</span></span>
      </div>
    </div>
  </div>
</div>

<div class="col-sm-12 col-md-4 mt-3">
  <div class="row">
    <div class="text-center col-sm-12">
      <h2 tabindex="0" attr.aria-label="selected date, {{
          selectedDate | date : 'EEEE d MMMM'
        }}">
        {{ selectedDate | date : 'EEEE d MMMM' }}
      </h2>
      <hr />
      <span class="invalid-feedback" *ngIf="slots?.length == 0" tabindex="0">
        No available booking slots left for today – please try another day</span>
    </div>

    <div *ngFor="let slot of slots" class="col-4 col-sm-4 col-md-6">
      <button class="slot-btn" (click)="selectSlot(slot)"
        [ngClass]="{ 'selected-slot-btn': selectedSlot?.start === slot?.start }">
        {{ slot?.start | date : 'HH:mm' }}
      </button>
    </div>
  </div>
</div>